import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h4>{`Apple Pay`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Error ID`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Recovery Suggestion`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`apple-pay-timed-out`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicates that the Apple Pay request timed out.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Make sure you have an active internet connection and your Apple Pay configuration is correct.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`unable-to-present-apple-pay`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicates that the Apple Pay sheet failed to display.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ensure device supports Apple Pay and that it is setup correctly. Check debug console for system errors.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      